import React from 'react';
import PropTypes from 'prop-types';
import BBQuery from './BBQuery.js';
import SavingBackdrop from '../Forms/SavingBackdrop.js';

// uses render props pattern - https://reactjs.org/docs/render-props.html
// in this case prop is 'children' not 'render' but its the same concept

class AdminSearch extends React.Component {
  render () {
    const { children, query, options, fetchPolicy } = this.props;
    return (
      <BBQuery
        query={query(options)}
        fetchPolicy={fetchPolicy}
        loaderComponent={<SavingBackdrop open text='Loading...' />}
      >
        {(data, refetch) => {
          return children(data, refetch);
        }}
      </BBQuery>
    );
  }
}

AdminSearch.propTypes = {
  children: PropTypes.func.isRequired,
  query: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  fetchPolicy: PropTypes.string
};

export default AdminSearch;
